import { config } from 'env_def';
import { ActionStore, methodMap, watchConf, } from './mail_action_store_model';
import { api } from '@/api/api';
import { ErrMsgCodeMap, ErrResult } from '@/api/errMap';
import { SIZE_UNIT } from '@/api/util';
import { apis } from '@/config';
import { FolderTreeEditState } from '@/api/logical/mail';
import corpMailUtils from './corp_mail_utils';
import { getOs, getWebOsByUA } from '../../../utils/confOs';
import { getIn18Text } from '@/api/utils';
const os = process.env.BUILD_ISWEB ? 'web_' + getWebOsByUA() : getOs() || 'web';
export const xMailerExt = (process.env.BUILD_ISEDM ? 'Waimao_' : 'Sirius_') + os.toUpperCase() + '_' + config('version');
export class MailAbstractHandler {
    constructor(actions, modelHandler, contactHandler, mailDbHandler, subActions) {
        this.commonConfig = {
            contentType: 'json',
            responseType: 'text',
            method: 'post',
            expectedResponseType: 'json',
        };
        this.host = config('host');
        this.domain = config('domain');
        this.dbEnableKey = 'mailDbEnable';
        this.mailDbHanlder = mailDbHandler;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.eventApi = api.getEventApi();
        this.impl = api.getDataTransApi();
        this.pushApi = api.requireLogicalApi(apis.pushApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.mailSigApi = api.requireLogicalApi(apis.mailSignatureImplApi);
        this.db = api.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.modelHandler = modelHandler;
        this.contactHandler = contactHandler;
        this.actions = actions;
        this.subActions = subActions;
        this.errReporter = api.requireLogicalApi(apis.errorReportImpl);
        this.dataTrakerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.htmlApi = api.requireLogicalApi(apis.htmlApi);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        const buildKeys = (info, st) => {
            const ret = [];
            Object.keys(info).forEach(it => {
                const t = info[it];
                t && t[st] && ret.push(methodMap[it]);
            });
            return ret;
        };
        this.watchUrlKey = buildKeys(watchConf, 'updateStatus');
        this.cacheUrlKey = buildKeys(watchConf, 'cache');
    }
    buildUrl(key, additionalParam, noSid, _account, urlPath) {
        return this.modelHandler.buildUrl({ key, additionalParam, urlPath, noSid, _account });
    }
    buildPriaseUrl(key, additionalParam, _account) {
        return this.modelHandler.buildUrl({ key, additionalParam, urlPath: 'sendPraise', _account });
    }
    buildVariableEmailUrl(key, additionalParam, _account) {
        let resp = this.modelHandler.buildUrl({ key, additionalParam, urlPath: 'sendVariableMail', _account });
        let node = this.systemApi.getCurrentNode();
        return resp + `&node=${node}`;
    }
    buildDyncGroupSendMailUrl(key, additionalParam, _account) {
        let resp = this.modelHandler.buildUrl({ key, additionalParam, urlPath: 'sendDyncGroupSendMail', _account });
        let node = this.systemApi.getCurrentNode();
        return resp + `&node=${node}`;
    }
    buildCreateTaskUrl(key, additionalParam, _account) {
        return this.modelHandler.buildUrl({ key, additionalParam, urlPath: 'createTask', _account });
    }
    commonCatch(reason, additionalInfo, extraObj) {
        console.log('commonCatch', reason);
        if (typeof reason === 'object' && reason.code && reason.title && reason.popupType) {
            return reason;
        }
        if (reason instanceof Error) {
            return this.getErrMsg(reason.message);
        }
        if (typeof reason === 'string') {
            return this.getErrMsg(reason, undefined, additionalInfo, extraObj);
        }
        return MailAbstractHandler.defaultErrInfo;
    }
    getMailErrMsg(err, type, additionalInfo) {
        if (err && err.code) {
            return this.getErrMsg(err.code);
        }
        return {
            code: err.code === undefined ? type || '' : err.code + '',
            title: additionalInfo || ErrMsgCodeMap.UNKNOWN_ERR,
        };
    }
    getErrMsg(errMsg, defaultMsg, additionalInfo, extraObj) {
        if (errMsg) {
            let errInfo = null;
            if (extraObj === null || extraObj === void 0 ? void 0 : extraObj.errResult) {
                errInfo = extraObj === null || extraObj === void 0 ? void 0 : extraObj.errResult[errMsg];
            }
            else {
                errInfo = ErrResult[errMsg];
            }
            if (errInfo) {
                let messageInfo = Object.assign({}, errInfo);
                if (process.env.BUILD_ISEDM) {
                    const yingxiaoError = ['FA_MTA_REJECTED5540', 'FA_MTA_REJECTED4512', 'FA_MTA_REJECTED5910'];
                    if (yingxiaoError.includes(errMsg)) {
                        messageInfo = Object.assign(Object.assign({}, messageInfo), { popupLevel: 'confirm', btnConfirmTxt: getIn18Text('QUFAYINGXIAOYOUJ'), btnCancelTxt: getIn18Text('ZHIDAOLE'), edmJump: true, forcePopup: true, confirmCallback: () => {
                                this.eventApi.sendSimpleSysEvent('sendMailFailJumpYingxiao');
                            } });
                    }
                }
                if (errMsg === 'FA_MTA_REJECTED5511') {
                    messageInfo = Object.assign(Object.assign({}, messageInfo), { btnConfirmTxt: '解 禁', confirmCallback: () => corpMailUtils.applyUnban(extraObj) });
                }
                if (errMsg === 'FA_OVERFLOW') {
                    messageInfo = Object.assign(Object.assign({}, messageInfo), { overflowReason: extraObj === null || extraObj === void 0 ? void 0 : extraObj.overflowReason });
                }
                if (messageInfo.popupType && (messageInfo.popupType === 'window' || messageInfo.popupType === 'toast')) {
                    messageInfo.content += additionalInfo || '';
                    if (errMsg !== 'FA_MAIL_NOT_FOUND') {
                        this.eventApi.sendSysEvent({
                            eventName: 'error',
                            eventLevel: 'error',
                            eventStrData: '',
                            eventData: messageInfo,
                            eventSeq: 0,
                        });
                        messageInfo = Object.assign(Object.assign({}, messageInfo), { remindWay: 'event' });
                    }
                    else {
                    }
                }
                return messageInfo;
            }
            if (errMsg in ErrMsgCodeMap) {
                return {
                    title: ErrMsgCodeMap[errMsg],
                    code: errMsg + '',
                };
            }
        }
        return {
            title: (errMsg ? errMsg + '' : undefined) || defaultMsg || ErrMsgCodeMap.UNKNOWN_ERR,
            code: 'UNKNOWN_ERR',
        };
    }
    getConfigForHttp(urlKey, httpConfig) {
        const ret = Object.assign(Object.assign({}, this.commonConfig), httpConfig);
        ret.tag = urlKey;
        const element = watchConf[urlKey];
        if (element) {
            if (element.immutable) {
            }
            else if (element.cache) {
                const methodStatus = this.actions.methodStatus[urlKey];
                if (methodStatus) {
                    this.impl.getUrlPath(httpConfig);
                }
            }
            else {
            }
        }
        ret.cachePolicy = ret.cachePolicy || 'noCache';
        return ret;
    }
    setDbEnable(flag) {
        ActionStore.dbEnable = flag;
        this.storeApi.put(this.dbEnableKey, String(ActionStore.dbEnable)).then().catch(console.warn);
    }
    buildInitContent(param) {
        return this.modelHandler.buildInitContent(param);
    }
    mappingToMailBoxEntry(data, _account) {
        var _a;
        const dt = [];
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions) {
            data.forEach((item, index) => {
                var _a;
                if (item) {
                    const { id } = item;
                    const stats = item.stats || {};
                    const flags = item.flags || {};
                    const entry = {
                        mailBoxName: item.name,
                        mailBoxCurrentUnread: stats.unreadMessageCount || 0,
                        mailBoxUnread: stats.unreadMessageCount || 0,
                        mailBoxTotal: stats.messageCount || 0,
                        mailBoxType: flags.system ? 'sys' : 'customer',
                        mailBoxId: id,
                        threadMailBoxCurrentUnread: Math.max(stats.unreadThreadCount || 0, 0),
                        threadMailBoxUnread: Math.max(stats.unreadThreadCount || 0, 0),
                        threadMailBoxTotal: Math.max(stats.threadCount || 0, 0),
                        mailBoxParent: item.parent,
                        id: '' + (((_a = actions.mailBoxConfs[id]) === null || _a === void 0 ? void 0 : _a.sort) || id),
                        pid: item.parent,
                        locked: item.auth2Locked,
                        keepPeriod: item.keepPeriod,
                        sort: index,
                        _state: FolderTreeEditState.DEFAULT,
                        _deep: 0,
                        _isTempNode: false,
                        messageSize: stats.messageSize || 0,
                    };
                    dt.push(entry);
                }
            });
        }
        return dt;
    }
    saveMailContentToAction(mailBoxModels, mailBoxEntry, _account) {
        this.modelHandler.saveMailBoxContentToAction(mailBoxModels, mailBoxEntry, _account);
    }
    generateRndId() {
        return this.modelHandler.generateRndId();
    }
    makeModelSafe(entry) {
        entry.entry.content = entry.entry.content || {
            content: '',
            contentId: '',
        };
        entry.receiver = entry.receiver || [];
        entry.sender = entry.sender || this.contactHandler.buildEmptyContact(false)[0];
        return entry;
    }
    getAccountSession(_account) {
        const result = {
            _session: '',
            sid: '',
        };
        const accounts = this.accountApi.getLocalSubAccountsFromCache({
            subAccountEmail: _account,
            expired: false,
        });
        const account = accounts.find((it) => it.id === _account);
        if (account) {
            result._session = '';
            result.sid = account.sessionId;
        }
        return result;
    }
}
MailAbstractHandler.MAX_CACHE_ALIVE_SPAN = 1000 * 3600 * 24 * 7;
MailAbstractHandler.COMMON_CACHE_ALIVE_SPAN = 1000 * 3600;
MailAbstractHandler.COMMON_ATTACHMENT_LOCK_NAME = 'mailAttachmentUploadLock';
MailAbstractHandler.COMMON_DEL_ATTACHMENT_LOCK_NAME = 'mailAttachmentDelLock';
MailAbstractHandler.searchFields = 'from,to,subj,cont,aname';
MailAbstractHandler.mailSearchSeq = 'mailSearchSeq';
MailAbstractHandler.mailSearchKeyWord = 'mailSearchKeyWord';
MailAbstractHandler.comNotExist = config('notExistUrl');
MailAbstractHandler.sOk = 'S_OK';
MailAbstractHandler.SuccessCode = 200;
MailAbstractHandler.tmpIdFormat = /[0-9]+-tmp/i;
MailAbstractHandler.MAX_ATTACHMENT_ALLOWED_SIZE = 16 * SIZE_UNIT * SIZE_UNIT * SIZE_UNIT;
MailAbstractHandler.MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE = 5 * SIZE_UNIT * SIZE_UNIT * SIZE_UNIT;
MailAbstractHandler.FREE_MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE = 1 * SIZE_UNIT * SIZE_UNIT * SIZE_UNIT;
MailAbstractHandler.OTHER_MAX_SINGLE_ATTACHMENT_ALLOWED_SIZE = 3 * SIZE_UNIT * SIZE_UNIT * SIZE_UNIT;
MailAbstractHandler.useLegacyUpload = false;
MailAbstractHandler.defaultRequestListMailEntry = {
    limit: 50,
    start: 0,
    summaryWindowSize: 50,
    returnTotal: true,
    returnTid: true,
    returnTag: true,
    returnAttachments: true,
    order: 'date',
    desc: true,
    skipLockedFolders: false,
};
MailAbstractHandler.composeUrlParam = {
    save: {
        l: 'compose',
        action: 'save',
        xMailerExt,
    },
    deliver: {
        l: 'compose',
        action: 'deliver',
        xMailerExt,
    },
};
MailAbstractHandler.user = undefined;
MailAbstractHandler.defaultErrInfo = {
    popupType: 'window',
    title: ErrMsgCodeMap['SERVER.ERR'],
    code: 'SERVER.ERR',
};
